


























































import { Component, Prop, Watch } from "vue-property-decorator";
import EntityType from '@/models/Shared/EntityType';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import DocumentDto from "@/models/Documents/DocumentDto";
import UploadDocumentRequest from "@/models/Documents/UploadDocumentRequest";
import FileWithExpiry from '@/models/Documents/FileWithExpiry';


@Component({
  name: "DocumentUpload",
})
export default class extends GiganautVueDialog {
  
  @Prop({required: true})
  entityType: EntityType;
  public isExpiryTracked = false;
  public expiresAt = '';
  public file: File = null;
  public dialog = false;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.isExpiryTracked = false;
      this.expiresAt = "";
      this.file = null;
    }
  }

  async upload() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const fileWithExpiry = new FileWithExpiry();
    fileWithExpiry.file = this.file;
    fileWithExpiry.isExpiryTracked = this.isExpiryTracked;
    fileWithExpiry.expiresAt = this.expiresAt;

    switch (this.entityType){
        case EntityType.Booking:
            //await BookingDetailsModule.uploadDocument(this.file);
            break;
        case EntityType.Worker:
            await WorkerDetailsModule.uploadDocument(fileWithExpiry);
            break;
        case EntityType.Company:
            await CompanyDetailsModule.uploadDocument(fileWithExpiry);
            break;
        case EntityType.Contact:
            //await ContactDetailsModule.uploadDocument(this.file);
            break;
        case EntityType.Location:
            await LocationDetailsModule.uploadDocument(fileWithExpiry);
            break;
        case EntityType.Opportunity:
            await OpportunityDetailsModule.uploadDocument(fileWithExpiry);
            break;
    }
    this.dialog = false;
  }
}
